<template>
  <b-container>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.userManagement") }}</h1>

    <div v-if="spinner" class="text-center">
      <b-spinner
        style="width: 3rem; height: 3rem"
        variant="success"
        label="Spinning"
        disabled="labelStatus"
      ></b-spinner>
    </div>

    <div v-else class="text-center">
      <b-row class="mt-2">
        <b-col sm="4" class="mt-4">
          <b-form-select
            v-model="building"
            :options="buildings"
            v-on:change="OnBuildingClick"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>

    <div class="mt-2" v-if="userslist.length > 0">
      <b-row class="pt-2">
        <b-col sm="4" class="mt-2">
          <b-form-select v-model="perPage" :options="options"></b-form-select>
        </b-col>
        <b-col sm="4" class="mt-2">
          <b-form-input
            v-model="search"
            :placeholder="$t('action.search')"
          ></b-form-input>
          <b-button variant="link" @click="resetTable()">{{
            $t("action.reset")
          }}</b-button>
        </b-col>
        <b-col sm="4" class="mt-2">
          <div>{{ $t("label.tablesize") }} {{ rows }}</div>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col class="lgTable">
          <b-table
            id="UsersTable"
            stacked="lg"
            bordered
            :fields="myfields"
            :items="items"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template v-slot:cell(details)="row">
              <b-button class="ml-2" size="sm" @click="editUser(row.item)">{{
                $t("action.update")
              }}</b-button>
              <!--<b-button class="ml-2" size="sm" @click="editBuildingForUser(row.item)">{{ $t("action.editBuildingForUser") }}</b-button>-->
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col sm="6" class="mt-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="UsersTable"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>

    <div v-else>
      <div v-if="!spinner">
        <div v-if="building" class="text-center pt-2">
          {{ $t("label.emptyUser") }}
        </div>
      </div>
    </div>

    <b-row v-if="!spinner" class="pt-4">
      <b-col class="mt-2">
        <b-button variant="success" @click="addUser()">{{
          $t("action.addUser")
        }}</b-button>
      </b-col>
    </b-row>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import { mappBuildingDataForSelect } from "../../../assets/Utils.js";
import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  data() {
    return {
      error: "",
      allBuilding: [],
      buildings: [],
      building: this.getbuilding(),
      sortBy: "LocationDate",
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      search: "",
      userslist: [],
      selected: [],
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      notifications: [],
      spinner: false,
    };
  },
  mounted() {
    this.ajaxCall();
  },
  computed: {
    rows() {
      return this.items.length;
    },
    items: function () {
      let mydatalist = this.userslist;
      let search = this.search.toLowerCase();
      return mydatalist.filter(
        (p) =>
          p.fname.toLowerCase().includes(search) ||
          p.lname.toLowerCase().includes(search) ||
          p.email.toLowerCase().includes(search) ||
          p.RoleName.toLowerCase().includes(search) ||
          p.Creation.toLowerCase().includes(search)
      );
    },
    myfields: function () {
      return [
        { key: "fname", sortable: true, label: this.$t("label.fname") },
        { key: "lname", sortable: true, label: this.$t("label.lname") },
        { key: "email", sortable: true, label: this.$t("label.email") },
        { key: "RoleName", sortable: true, label: "Role" },
        { key: "Creation", sortable: true, label: this.$t("label.date") },
        { key: "details", label: this.$t("label.detail") },
      ];
    },
  },
  methods: {
    editUser: function (user) {
      let userBuildingList = [];
      let buildings = this.allBuilding;
      let userBuilding = this.usersBuilding;
      let buildingList = userBuilding.filter((u) => u.IdUser === user.Id);

      if (buildingList.length > 0) {
        for (let i = 0; i < buildingList.length; i++) {
          let idBuilding = buildingList[i].IdBuilding;
          let found = buildings.find((b) => b.Id === idBuilding);
          if (found) {
            userBuildingList.push(found);
          }
        }
      }
      this.$store.commit("addUserToEdit", user);
      this.$store.commit("addBuildingListForUser", userBuildingList);
      this.$store.commit("addBuildingsList", buildings);
      this.$emit("changePage", "EditUser");
    },
    /*editBuildingForUser: function (user) {
        this.$store.commit('addUserToEdit', user);
        this.$emit('changePage', 'EditBuildingForUser');
      },*/
    addUser: function () {
      this.$store.commit("addUserToEdit", null);
      this.$emit("changePage", "AddNewUser");
    },
    OnBuildingClick: function () {
      let selected = this.building;
      let userBuilding = this.usersBuilding;
      let allUsers = this.$store.getters.getUserList;
      this.search = "";

      if (selected) {
        let matchList = userBuilding.filter(
          (u) => u.IdBuilding === selected.Id
        );
        let myList = [];

        for (let i = 0; i < matchList.length; i++) {
          let found = allUsers.find((a) => a.Id === matchList[i].IdUser);
          if (found) {
            myList.push(found);
          }
        }

        this.userslist = myList;
      }
    },
    getbuilding: function () {
      return null;
    },
    ajaxCall() {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            url,
            { request: "getAllUser" },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            this.spinner = false;
            this.$store.commit("setReloadValue", false);
            this.$store.commit("addUserList", response.data.users);
            this.userslist = response.data.users;
            this.usersBuilding = response.data.userBuilding;
            this.allBuilding = response.data.buildings;
            this.setBuildingList(response.data.buildings);
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      });
    },
    setBuildingList: function (buildings) {
      let res = [];
      if (buildings) {
        res = mappBuildingDataForSelect(buildings);
        //res.unshift({value: 'All', text: this.$t('label.all')});
      }
      res.unshift({ value: null, text: this.$t("label.properties") });
      this.buildings = res;
    },
    resetTable: function () {
      this.search = "";
      this.userslist = this.$store.getters.getUserList;
      this.building = null;
    },
    setNextPage(page) {
      this.$emit("changePage", page);
    },
  },
};
</script>
